module.exports = __webpack_public_path__ + "img/earth.0a879fc7.svg";